module.exports = __webpack_public_path__ + "assets/d4c9c9bd473f57a9945a9d98f3c472a8.png";